export function sourceDocument(value = '') {
  const doc = new DOMParser().parseFromString(String(value), 'text/html');
  doc.querySelectorAll('script,style,iframe,object').forEach(node => node.remove());
  doc.querySelectorAll('td,th').forEach(node => node.append('\t'));
  doc.querySelectorAll('p,div,br,li,tr,h1,h2,h3,h4,h5,h6').forEach(node => node.append('\n'));
  return doc;
}
export function sourcePlainText(value = '') {
  return sourceDocument(value).body.textContent.trim();
}
